import Image from "next/image";
import styles from "./styles.module.scss";

interface StaffProps {
  name: string;
  image: string;
  description: string[];
}

export default function StaffCard({ name, image, description }: StaffProps) {
  return (
    <section className={styles.container}>
      <div className={styles.title}>
        <div className={styles.image}>
          <Image src={image} alt={name} width="158" height="158" />
        </div>
        <h3>{name}</h3>
      </div>
      <ul className={styles.description}>
        {description.map((item, index) => (
          <li key={`${name}-${index}`}>{item}</li>
        ))}
      </ul>
    </section>
  );
}
